export const getDateFromUnknown = <T = Date>(unknown: unknown, defaultDate: T = new Date() as unknown as T) => {
  if (!unknown) return defaultDate;

  const isValidDate = new Date(unknown as string).toString() !== 'Invalid Date';

  return isValidDate ? new Date(unknown as string) : defaultDate;
};
